import { render, staticRenderFns } from "./persistent_bottom.vue?vue&type=template&id=0e7b7ce6&scoped=true&"
import script from "./persistent_bottom.vue?vue&type=script&lang=js&"
export * from "./persistent_bottom.vue?vue&type=script&lang=js&"
import style0 from "./persistent_bottom.vue?vue&type=style&index=0&id=0e7b7ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7b7ce6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e7b7ce6')) {
      api.createRecord('0e7b7ce6', component.options)
    } else {
      api.reload('0e7b7ce6', component.options)
    }
    module.hot.accept("./persistent_bottom.vue?vue&type=template&id=0e7b7ce6&scoped=true&", function () {
      api.rerender('0e7b7ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/persistent_bottom.vue"
export default component.exports